module.exports = __webpack_public_path__ + "img/about-pic.70d56dc9.png";